import { DOCXPreview, PDFPreview } from "../../../../../components"

const buildPdfUrl = (src) =>
  src.includes("#")
    ? `${src}&toolbar=0&navpanes=0&view=FitH`
    : `${src}#toolbar=0&navpanes=0&view=FitH`

const buildDocxUrl = (src) => {
  // Use Google Docs Viewer for DOCX files
  return `https://docs.google.com/gview?url=${encodeURIComponent(
    src
  )}&embedded=true`
}

const MobilePager = ({
  page,
  pagerRef,
  pageWidth,
  viewportWidth,
  leftPane,
  document,
  onCloseDocument,
  handleHorizontalScroll,
}) => {
  const pdfUrl =
    document?.storageUrl &&
    /\.pdf(\?|$)/i.test(document.storageUrl || document?.fileName || "")
      ? buildPdfUrl(document.storageUrl)
      : null

  const docxUrl =
    document?.storageUrl &&
    /\.docx?(\?|$)/i.test(document.storageUrl || document?.fileName || "")
      ? buildDocxUrl(document.storageUrl)
      : null

  return (
    <div className="h-full flex flex-col min-h-0">
      {/* dots */}
      <div className="w-full flex justify-center items-start py-4">
        <div className="flex items-center gap-2">
          <div
            className={`w-2.5 h-2.5 rounded-full ${
              page === 0
                ? "bg-dark-default"
                : "bg-transparent  border-dark-default"
            }`}
          />
          <div
            className={`w-2.5 h-2.5 rounded-full ${
              page === 1
                ? "bg-dark-default"
                : "bg-transparent  border-dark-default"
            }`}
          />
        </div>
      </div>

      {/* horizontal pager */}
      <div
        ref={pagerRef}
        onScroll={handleHorizontalScroll}
        className="w-full flex-1 min-h-0 overflow-x-auto overflow-y-hidden scrollbar-hide"
        style={{
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          touchAction: "pan-x",
        }}
      >
        <div
          className="flex justify-between h-full"
          style={{ width: viewportWidth + pageWidth - 10 }}
        >
          {/* left page */}
          <div
            className="snap-start pl-4 h-full"
            style={{ width: pageWidth - 10 }}
          >
            <div className="h-full flex flex-col">
              <div className="flex-1 min-h-0 overflow-hidden">{leftPane}</div>
            </div>
          </div>

          {/* right page (document) */}
          <div
            className="snap-start mr-4 h-full"
            style={{ width: pageWidth + 10 }}
          >
            <div className="mb-3 bg-[#121212] rounded-[28px] shadow-lg inline-flex flex-col self-stretch w-full h-full">
              {/* header */}
              <div className="px-4 py-3 flex items-center justify-between text-white/90">
                <h2
                  className="text-lg font-semibold text-light-default"
                  style={{ fontSize: 36 }}
                >
                  The contract
                </h2>
                <button
                  onClick={onCloseDocument}
                  className="w-8 h-8 rounded-full flex items-center justify-center text-light-default/90"
                  aria-label="Close"
                >
                  <span className="leading-none" style={{ fontSize: 42 }}>
                    ×
                  </span>
                </button>
              </div>

              {/* viewer */}
              <div className="p-3 flex-1 min-h-0 flex">
                <div className="w-full rounded-2xl bg-white flex-1 min-h-0 overflow-hidden">
                  <div
                    className="h-full min-h-0 overflow-y-auto -mr-1 pr-1"
                    style={{
                      WebkitOverflowScrolling: "touch",
                      overscrollBehavior: "contain",
                      touchAction: "pan-y",
                    }}
                  >
                    {document?.storageUrl ? (
                      pdfUrl ? (
                        <object
                          key={pdfUrl}
                          data={pdfUrl}
                          type="application/pdf"
                          className="block w-full h-full bg-white"
                        >
                          <iframe
                            key={pdfUrl}
                            title="PDF"
                            src={pdfUrl}
                            className="block w-full h-full bg-white"
                          />
                        </object>
                      ) : docxUrl ? (
                        <iframe
                          key={docxUrl}
                          title="DOCX"
                          src={docxUrl}
                          className="block w-full h-full bg-white"
                          style={{ border: "none" }}
                        />
                      ) : (
                        <>
                          {document?.type === "application/pdf" ? (
                            <PDFPreview file={document} isMobile embed />
                          ) : (
                            <DOCXPreview file={document} isMobile />
                          )}
                        </>
                      )
                    ) : (
                      <>
                        {document?.type === "application/pdf" ? (
                          <PDFPreview file={document} isMobile embed />
                        ) : (
                          <DOCXPreview file={document} isMobile />
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobilePager
